import styled, { css } from "styled-components";
import { color, highContrastStyle, onHover, typeStyle, units, variant } from "@m/alchemy-theme";
import { navHeight } from "../navHeight";
import { MOBILE_BREAKPOINT } from "../constants";
export const AppNavListItem = styled.li `
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ priority }) => priority &&
    css `
      ${navHeight({ priority })};
    `};

  a {
    padding: 0px ${units(1.5)};
    text-decoration: none;
  }

  button,
  a {
    position: relative;
    display: flex;
    align-items: center;
    align-self: stretch;
    width: auto;
    white-space: nowrap;
    cursor: pointer;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    [data-whatinput="touch"] &,
    [data-whatinput="mouse"] & {
      outline: none;
    }

    color: ${color("typeHeader")};
    ${typeStyle("bodyM")};
    letter-spacing: 0.2px;
    line-height: 1;
    opacity: ${highContrastStyle("1", "0.85")};
    transition: all cubic-bezier(0.4, 0, 0.4, 1) 0.2s;

    ${({ priority }) => priority &&
    css `
        ${navHeight({ priority, shouldHavePadding: true })};
      `};

    ${({ isActive, priority }) => isActive &&
    priority &&
    css `
        ${variant("priority", {
        primary: css `
            font-size: 18px;
            -webkit-font-smoothing: unset;
            -moz-osx-font-smoothing: unset;
          `,
        secondary: css `
            font-size: 20px;
            -webkit-font-smoothing: unset;
            -moz-osx-font-smoothing: unset;
          `
    })};

        opacity: 1;
      `};

    @media (min-width: ${MOBILE_BREAKPOINT}px) {
      ::after {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        left: calc(50% - 3px);
        background-color: ${color("typeHeader")};
        opacity: 0;
        transition: all ease 0.1s;
        bottom: ${({ priority }) => (priority === "secondary" ? units(1.5) : units(1))};
      }
    }

    ${({ isActive }) => isActive &&
    css `
        opacity: 1;

        ::after {
          opacity: 1;
        }
      `};

    ${onHover(css `
        animation-timing-function: cubic-bezier(0, 0.1, 1);
        animation-duration: 0.1s;
        opacity: 1;
      `, { includeActive: true })}

    svg {
      width: ${units(2)};
      height: ${units(2)};
      margin-right: ${units(1)};
      size: ${units(2)};
    }
  }
`;
